export type UpscGsPaperTagStyle = {
  background: string;
  color: string;
};

/** Rotating palette for GS paper tags — cycles by tag index */
export const UPSC_GS_PAPER_TAG_PALETTE: UpscGsPaperTagStyle[] = [
  {
    background: 'var(--color-i-green-12)',
    color: 'var(--color-i-green-4)'
  },
  {
    background: 'var(--color-i-blue-11)',
    color: 'var(--color-accent-blue)'
  },
  {
    background: 'var(--color-red-2)',
    color: 'var(--color-i-red)'
  },
  {
    background: 'var(--color-i-yellow-3)',
    color: 'var(--color-i-yellow-10)'
  }
];

export const getUpscGsPaperTagStyle = (index: number): UpscGsPaperTagStyle => {
  const paletteLength = UPSC_GS_PAPER_TAG_PALETTE.length;

  if (paletteLength === 0) {
    return {
      background: 'var(--color-base-light-0)',
      color: 'var(--color-text-secondary)'
    };
  }

  return UPSC_GS_PAPER_TAG_PALETTE[index % paletteLength];
};
